import React from 'react'

import { IProps } from 'marketing-site/src/library/components/BasicHeader'
import { IntercomIsotype } from 'marketing-site/src/library/elements/IntercomIsotype'
import { Text } from 'marketing-site/src/library/elements/Text'
import { Color } from 'marketing-site/src/library/utils'

export class BasicHeader extends React.PureComponent<IProps> {
  render(): React.ReactElement {
    const { logoText } = this.props
    return (
      <>
        <div className="header-content-wrapper">
          <a href="/" aria-label="Intercom Home" className="header-logo-link">
            <div className="header-logo">
              <IntercomIsotype contentType="grid" theme="light" />
            </div>
            {logoText && (
              <Text brand="default" size="button-bold">
                {logoText}
              </Text>
            )}
          </a>
        </div>
        <style jsx>
          {`
            .header-content-wrapper {
              padding: 30px 40px;
              background: ${Color.Stone};
            }

            .header-logo-link {
              display: flex;
              align-items: center;
              color: ${Color.Slate};
            }

            .header-logo {
              margin-right: 30px;
            }

            @media (min-width: 768px) {
              .header-content-wrapper {
                padding: 59px 76px;
              }
            }
          `}
        </style>
      </>
    )
  }
}
